export default __webpack_public_path__ + "static/media/img-v3-launch-mobile-1.daa77573.png";